<div class="h-100 na-wrapper">
    <img src="../../../assets/images/wip.svg" alt="work in progress" class="h-40">
</div>